const GLOBAL_CHAT_ALLOWED_USERNAMES = new Set([
  'victorbar',
  'victorbar2',
  'jamie',
  'vas',
  'nevitup',
  'tenduklar',
  'tendulkar',
  'rajkopfc',
  'karol',
  'tockipo',
  'eloy',
  'liviutrandafir',
  'rorytolintino',
  'karolsilva',
]);

export const canShowGlobalChat = (username?: string): boolean => (
  GLOBAL_CHAT_ALLOWED_USERNAMES.has((username || '').trim().toLowerCase())
);
